import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router';
import { AuthGate } from './app/auth-gate';
import { Layout } from './app/layout';
import { Admin } from './routes/admin';
import { Goal } from './routes/goal';
import { History } from './routes/history';
import { Plan } from './routes/plan';
import { Today } from './routes/today';
import { Trends } from './routes/trends';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Meals get logged from LINE while this view is open, so a short stale
      // window keeps the day's total honest without hammering the API.
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Today /> },
      { path: 'plan', element: <Plan /> },
      { path: 'history', element: <History /> },
      { path: 'trends', element: <Trends /> },
      { path: 'goal', element: <Goal /> },
      { path: 'admin', element: <Admin /> },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthGate>
        <RouterProvider router={router} />
      </AuthGate>
    </QueryClientProvider>
  </StrictMode>,
);
